// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"264":"f98e28cd","478":"8401815d","787":"8cd36fc6"}[chunkId] + ".chunk.js";
};